import React, { useState } from "react";
import { Button, Form, Input, message } from "antd";
import { useAuthContext } from "../../components/AuthProvider";
import { useNavigate ,Link} from "react-router-dom";

const API_BASE = "Users/forgottenpassword";

function ForgotPassword() {
  const [form] = Form.useForm();
  const { token } = useAuthContext();
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  // const BASE_RETURN_URL = "http://localhost:3000/#/toss/reset/forgotpassword";
      const BASE_RETURN_URL = "https://synergytoss.net/#/toss/reset/forgotpassword";
    // const BASE_RETURN_URL = "https://toss.aoinnovations.org/#/toss/reset/forgotpassword";


  // Remove TypeScript syntax: no `: { username: string }`
  const handleFormSubmit = async (values) => {
    setSubmitting(true);

    try {
      const url = `${API_BASE}/${encodeURIComponent(
        values.username
      )}/${encodeURIComponent(BASE_RETURN_URL)}`;

      const response = await fetch(url, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          username: values.username,
          baseReturnUrl: BASE_RETURN_URL,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || "Failed to reset password");
      }

      message.success("Password reset request sent! Check your email.");
      form.resetFields();
    } catch (error) {
      message.error(error.message || "An error occurred while resetting password");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="container mt-4">
      <div className="card shadow p-4">
        <h4 className="text-start mb-4">Enter User Name</h4>

        <Form
          form={form}
          layout="vertical"
          onFinish={handleFormSubmit}
          disabled={submitting}
        >
          <Form.Item
            label="Username"
            name="username"
            rules={[
              { required: true, message: "Please enter your username!" },
              { min: 3, message: "Username must be at least 3 characters." },
            ]}
          >
            <Input
              placeholder="Enter your username"
              autoComplete="username"
              allowClear
            />
          </Form.Item>

          <Form.Item style={{ textAlign: "right", marginBottom: 0 }}>
            <Button
              type="primary"
              htmlType="submit"
              loading={submitting}
              style={{
                width: "30%",
                height: "40px",
                fontWeight: "bold",
                fontSize: "13px",
              }}
            >
              Reset Password
            </Button>
          </Form.Item>
        </Form>

          <div style={{ textAlign: "center" }}>
                    <Link to="/">Back to Login</Link>
                  </div>
      </div>
    </div>
  );
}

export default ForgotPassword;